export const resumeData = {
    experience: [
        {
            title: "Account Manager : 2022-2023",
            subtitle: "Prayagraj, Uttar Pradesh, India",
            description: "As an Account Manager at an EdTech company offering computer science courses globally for a year and a half, I engaged with instructors and decision-makers, delivered platform demos, ensured seamless after-sales services for platform-related concerns, developed and maintained customer relationships through effective communication and problem-solving skills, and provided technical support via phone, email, and online chat."
        },
        {
            title: "Project Manager : 2024-Present",
            subtitle: "Mumbai, India",
            description: "As a Project Manager at a Victoria-based company, I was responsible for engaging with customers to discuss technical specifications of government-provided products such as solar and hot water systems for businesses and households, assessing the environment to confirm product applicability for installation, assigning teams for installation, ensuring successful completion, coordinating product installations to ensure quality and timely execution, registering user and product details post-installation for government reference, and effectively communicating technical details to customers, enhancing clarity and satisfaction."
        }
    ],
    education: [
        {
            title: "Secondary Education (10th) : 2012 – 2013",
            subtitle: "St. ANNE’S HIGH SCHOOL & JUNIOR COLLEGE MUMBAI, MAHARASHTRA",
            description: "SCORE: 77%"
        },
        {
            title: "Higher Secondary Education (10th) : 2014 – 2015",
            subtitle: "VIVA COLLEGE OF SCIENCE MUMBAI, MAHARASHTRA",
            description: "SCORE: 65%"
        },
        {
            title: "BACHELOR OF ENGINEERING (MECHANICAL) : 2015 – 2021",
            subtitle: "ISB&M COLLEGE OF ENGINEERING PUNE, MAHARASHTRA",
            description: "SCORE: 7.32CGPA"
        },
        {
            title: "MERN STACK COURSE : 2024",
            subtitle: "EDYODA INSTITUTE BANGALORE",
            description: "CERTIFIED IN WEB DEVELOPMENT, REACTJS AND NODEJS"
        }
    ]
};
